export default __webpack_public_path__ + "static/media/UKR.11e07f6c.svg";